import I18n from 'lib/i18n'
import React from 'react'
import { useActions, useValues } from 'kea'
import PropTypes from 'prop-types'

import Checkbox from 'lib/forms/checkbox-svg'

import sceneLogic from '~/scenes/search/logic'
import naturalCompare from 'string-natural-compare'
import filtersLogic from '~/scenes/search/filters-page/logic'

export default function CategoryTags ({ fullScreenFiltersPage }) {
  const { unsavedFilter } = useValues(filtersLogic)
  const { updateUnsavedFilter } = useActions(filtersLogic)
  const { results } = useValues(sceneLogic)

  // all possible tags
  const categoryTags = results.category_tags

  // selected tags
  const selectedTags = {}
  unsavedFilter.category_tags
    .split(',')
    .filter(id => id.trim())
    .forEach(id => {
      selectedTags[parseInt(id).toString()] = true
    })

  categoryTags.forEach(tag => {
    if (selectedTags[tag.id] && !tag.is_master && tag.master_id) {
      selectedTags[tag.master_id] = true
    }
  })
  const sortedTags = []

  categoryTags
    .filter(tag => tag.is_master)
    .forEach(tag => {
      sortedTags.push(tag)
      categoryTags
        .filter(t => t.master_id === tag.id)
        .sort((a, b) => naturalCompare.caseInsensitive(a.title, b.title))
        .forEach(t => sortedTags.push(t))
    })

  categoryTags
    .filter(t => !t.is_master && !t.master_id)
    .sort((a, b) => naturalCompare.caseInsensitive(a.title, b.title))
    .forEach(t => sortedTags.push(t))

  function toggleTag (tagId) {
    // get array with tag added or removed
    let tags = Object.keys(selectedTags)
    if (tags.includes(tagId.toString())) {
      tags = tags.filter(tag => tag !== tagId.toString())
    } else {
      tags.push(tagId.toString())
    }

    // if we hide the main category tag, remove the subcategory tags for it
    const allTags = {}
    categoryTags.forEach(tag => {
      allTags[tag.id] = tag
    })

    const finalTags = []

    tags.forEach(tagId => {
      const tag = allTags[tagId]

      if (tag) {
        if (tag.is_master) {
          finalTags.push(tagId)
          categoryTags
            .filter(subTag => subTag.master_id === tagId)
            .forEach(subTag => {
              if (tags.includes(subTag.id.toString())) {
                finalTags.push(subTag.id.toString())
              }
            })
        } else if (!tag.master_id) {
          finalTags.push(tagId)
        } else {
          if (tags.includes(tag.master_id.toString())) {
            finalTags.push(tagId)
          }
        }
      }
    })

    updateUnsavedFilter({
      category_tags: finalTags.join(',')
    })
  }

  const filteredTags = sortedTags
    // show subtags only if master is selected
    .filter(tag => tag.is_master || !tag.master_id || selectedTags[tag.master_id])

  return (
    <div className='filter-section'>
      <div className='filter-title'>{I18n.t('react.search.all_filters.options')}</div>
      <div
        className='checkbox-list'
        style={{
          maxHeight: fullScreenFiltersPage ? 'unset' : 'calc(100vh - 300px)'
        }}
      >
        {filteredTags.map(tag => (
          <Checkbox key={tag.id} checked={!!selectedTags[tag.id]} onChange={() => toggleTag(tag.id)}>
            {tag.title}
          </Checkbox>
        ))}
      </div>
    </div>
  )
}

CategoryTags.propTypes = {
  fullScreenFiltersPage: PropTypes.bool
}
